export default "__VITE_ASSET__i2kMYX_9__"